import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_FOOTER_DATA, SET_FOOTER_DATA } from 'store/actionTypes';
import { GetDocService, SetDocService } from 'store/services/document';
import { message } from 'antd';

// watchers
export function* GetFooterDataWatcher() {
    yield takeEvery(GET_FOOTER_DATA.WATCH, GetFooterDataWorker);
}

export function* SetFooterDataWatcher() {
    yield takeEvery(SET_FOOTER_DATA.WATCH, SetFooterDataWroker);
}

// workers
function* GetFooterDataWorker({ payload }) {
    try {
        yield put({ type: GET_FOOTER_DATA.LOAD });
        const response = yield call(GetDocService, payload);
        yield put({ type: GET_FOOTER_DATA.SUCCESS, payload: response });
    } catch (e) {
        message.error(e.message);
        yield put({ type: GET_FOOTER_DATA.FAIL });
    }
}

function* SetFooterDataWroker({ payload }) {
    try {
        yield put({ type: SET_FOOTER_DATA.LOAD });
        yield call(SetDocService, payload);
        yield put({ type: SET_FOOTER_DATA.SUCCESS, payload: payload.data });
        message.success('Секция успешно обновлена');
    } catch (e) {
        message.error(e.message);
        yield put({ type: SET_FOOTER_DATA.FAIL });
    }
}

